"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingFrequency = void 0;
var BillingFrequency;
(function (BillingFrequency) {
    BillingFrequency["UNKNOWN"] = "unknown";
    BillingFrequency["DAILY"] = "daily";
    BillingFrequency["THREE_DAY"] = "three_day";
    BillingFrequency["WEEK"] = "week";
    BillingFrequency["MONTH"] = "month";
    BillingFrequency["THREE_MONTH"] = "three_month";
    BillingFrequency["SIX_MONTH"] = "six_month";
    BillingFrequency["YEAR"] = "year";
    BillingFrequency["LIFETIME"] = "lifetime";
})(BillingFrequency || (exports.BillingFrequency = BillingFrequency = {}));
